<app-service-detail>
    <div class="layer col-md-12 ml-auto pl-md-5" >
                    <div class="role-main-tabs d-flex">
                        <div class="role-tab {{activeTab === 'general' ? 'active-tab': ''}}"
                             (click)="notifyTabChange('general')">
                            {{ 'roles.generalTab' | translate }}
                        </div>
                        <div *ngIf="selectedBot && selectedBot.botType !== 'document'"
                             class="role-tab {{activeTab === 'bot-service' ? 'active-tab': ''}}"
                             (click)="notifyTabChange('bot-service')">
                            {{ 'roles.botservice' | translate }}
                        </div>
                    </div>

                    <div class="role-main-tabs-content">
                        <div class="role-tab-content tab-general {{activeTab === 'general' ? 'active-tab': ''}}">
                            <div class="role-tab-inner">
                                <role-bot-manage [fromRole]="true" (changedData)="updatedRole()"
                                                 (addedFromRoleEvent)="addedNewBot($event);" [serviceId]="serviceId"
                                                 [bot]="selectedBot" *ngIf="activeTab === 'general'"></role-bot-manage>
                            </div>
                        </div>
                        <div *ngIf="selectedBot && selectedBot.id  && selectedBot.botType !== 'document'"
                             class="role-tab-content tab-bot-service {{activeTab === 'bot-service' ? 'active-tab': ''}}">
                            <service-role *ngIf="role && role.type === 'BotRole'"
                                          [bot]="selectedBot" [serviceId]="serviceId">
                            </service-role>
                        </div>
                    </div>

                </div>
</app-service-detail>
